export default {
  et: {
    accept: 'Jah',
    addRule: 'Lisa reegel',
    am: 'AM',
    apply: 'Kinnita',
    cancel: 'Tühista',
    choose: 'Vali',
    chooseDate: 'Vali kuupäev',
    chooseMonth: 'Vali kuu',
    chooseYear: 'Vali aasta',
    clear: 'Tühjenda',
    completed: 'Completed',
    contains: 'Contains',
    custom: 'Custom',
    dateAfter: 'Date is after',
    dateBefore: 'Date is before',
    dateFormat: 'mm/dd/yy',
    dateIs: 'Kuupäev on',
    dateIsNot: 'Kuupäev ei ole',
    dayNames: [
      'Pühapäev',
      'Esmaspäev',
      'Teisipäev',
      'Kolmapäev',
      'Neljapäev',
      'Reede',
      'Laupäev',
    ],
    dayNamesMin: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
    dayNamesShort: ['Püh', 'Esm', 'Teis', 'Kolm', 'Nelj', 'Re', 'Laup'],
    emptyFilterMessage: 'Ei leidnud ühtegi tulemust',
    emptyMessage: 'Ei leidnud ühtegi valikut',
    emptySearchMessage: 'Ei leidnud ühtegi tulemust',
    emptySelectionMessage: 'Valik tegemata',
    endsWith: 'Ends with',
    equals: 'Equals',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    filter: 'Filter',
    firstDayOfWeek: 1,
    gt: 'Suurem kui',
    gte: 'Suurem või võrdne kui',
    lt: 'Väiksem kui',
    lte: 'Less than or equal to',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    medium: 'Medium',
    monthNames: [
      'Jaanuar',
      'Veebruar',
      'Märts',
      'Aprill',
      'Mai',
      'Juuni',
      'Juuli',
      'August',
      'September',
      'Oktoober',
      'November',
      'Detsember',
    ],
    monthNamesShort: [
      'Jaan',
      'Veeb',
      'Mär',
      'Apr',
      'Mai',
      'Juun',
      'Juul',
      'Aug',
      'Sept',
      'Okt',
      'Nov',
      'Dets',
    ],
    nextDecade: 'Next Decade',
    nextHour: 'Next Hour',
    nextMinute: 'Next Minute',
    nextMonth: 'Next Month',
    nextSecond: 'Next Second',
    nextYear: 'Next Year',
    noFilter: 'No Filter',
    notContains: 'Not contains',
    notEquals: 'Not equals',
    now: 'Nüüd',
    passwordPrompt: 'Enter a password',
    pending: 'Pending',
    pm: 'PM',
    prevDecade: 'Previous Decade',
    prevHour: 'Previous Hour',
    prevMinute: 'Previous Minute',
    prevMonth: 'Previous Month',
    prevSecond: 'Previous Second',
    prevYear: 'Previous Year',
    reject: 'Ei',
    removeRule: 'Remove Rule',
    searchMessage: '{0} tulemust saadaval',
    selectionMessage: '{0} valitud',
    showMonthAfterYear: false,
    startsWith: 'Starts with',
    strong: 'Strong',
    today: 'Täna',
    upload: 'Upload',
    weak: 'Weak',
    weekHeader: 'Wk',
    aria: {
      cancelEdit: 'Cancel Edit',
      close: 'Close',
      collapseLabel: 'Collapse',
      collapseRow: 'Row Collapsed',
      editRow: 'Edit Row',
      expandLabel: 'Expand',
      expandRow: 'Row Expanded',
      falseLabel: 'False',
      filterConstraint: 'Filter Constraint',
      filterOperator: 'Filter Operator',
      firstPageLabel: 'First Page',
      gridView: 'Grid View',
      hideFilterMenu: 'Hide Filter Menu',
      jumpToPageDropdownLabel: 'Jump to Page Dropdown',
      jumpToPageInputLabel: 'Jump to Page Input',
      lastPageLabel: 'Last Page',
      listView: 'List View',
      moveAllToSource: 'Move All to Source',
      moveAllToTarget: 'Move All to Target',
      moveBottom: 'Move Bottom',
      moveDown: 'Move Down',
      moveToSource: 'Move to Source',
      moveToTarget: 'Move to Target',
      moveTop: 'Move Top',
      moveUp: 'Move Up',
      navigation: 'Navigation',
      next: 'Next',
      nextPageLabel: 'Next Page',
      nullLabel: 'Not Selected',
      otpLabel: 'Please enter one time password character {0}',
      pageLabel: 'Page {page}',
      passwordHide: 'Hide Password',
      passwordShow: 'Show Password',
      previous: 'Previous',
      previousPageLabel: 'Previous Page',
      removeLabel: 'Remove',
      rotateLeft: 'Rotate Left',
      rotateRight: 'Rotate Right',
      rowsPerPageLabel: 'Rows per page',
      saveEdit: 'Save Edit',
      scrollTop: 'Scroll Top',
      selectAll: 'All items selected',
      selectLabel: 'Select',
      selectRow: 'Row Selected',
      showFilterMenu: 'Show Filter Menu',
      slide: 'Slide',
      slideNumber: '{slideNumber}',
      star: '1 star',
      stars: '{star} stars',
      trueLabel: 'True',
      unselectAll: 'All items unselected',
      unselectLabel: 'Unselect',
      unselectRow: 'Row Unselected',
      zoomImage: 'Zoom Image',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
    },
  },
  en: {
    accept: 'Yes',
    addRule: 'Add Rule',
    am: 'AM',
    apply: 'Apply',
    cancel: 'Cancel',
    choose: 'Choose',
    chooseDate: 'Choose Date',
    chooseMonth: 'Choose Month',
    chooseYear: 'Choose Year',
    clear: 'Clear',
    completed: 'Completed',
    contains: 'Contains',
    custom: 'Custom',
    dateAfter: 'Date is after',
    dateBefore: 'Date is before',
    dateFormat: 'mm/dd/yy',
    dateIs: 'Date is',
    dateIsNot: 'Date is not',
    dayNames: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    emptyFilterMessage: 'No results found',
    emptyMessage: 'No available options',
    emptySearchMessage: 'No results found',
    emptySelectionMessage: 'No selected item',
    endsWith: 'Ends with',
    equals: 'Equals',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    filter: 'Filter',
    firstDayOfWeek: 1,
    gt: 'Greater than',
    gte: 'Greater than or equal to',
    lt: 'Less than',
    lte: 'Less than or equal to',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    medium: 'Medium',
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    nextDecade: 'Next Decade',
    nextHour: 'Next Hour',
    nextMinute: 'Next Minute',
    nextMonth: 'Next Month',
    nextSecond: 'Next Second',
    nextYear: 'Next Year',
    noFilter: 'No Filter',
    notContains: 'Not contains',
    notEquals: 'Not equals',
    now: 'Now',
    passwordPrompt: 'Enter a password',
    pending: 'Pending',
    pm: 'PM',
    prevDecade: 'Previous Decade',
    prevHour: 'Previous Hour',
    prevMinute: 'Previous Minute',
    prevMonth: 'Previous Month',
    prevSecond: 'Previous Second',
    prevYear: 'Previous Year',
    reject: 'No',
    removeRule: 'Remove Rule',
    searchMessage: '{0} results are available',
    selectionMessage: '{0} items selected',
    showMonthAfterYear: false,
    startsWith: 'Starts with',
    strong: 'Strong',
    today: 'Today',
    upload: 'Upload',
    weak: 'Weak',
    weekHeader: 'Wk',
    aria: {
      cancelEdit: 'Cancel Edit',
      close: 'Close',
      collapseLabel: 'Collapse',
      collapseRow: 'Row Collapsed',
      editRow: 'Edit Row',
      expandLabel: 'Expand',
      expandRow: 'Row Expanded',
      falseLabel: 'False',
      filterConstraint: 'Filter Constraint',
      filterOperator: 'Filter Operator',
      firstPageLabel: 'First Page',
      gridView: 'Grid View',
      hideFilterMenu: 'Hide Filter Menu',
      jumpToPageDropdownLabel: 'Jump to Page Dropdown',
      jumpToPageInputLabel: 'Jump to Page Input',
      lastPageLabel: 'Last Page',
      listView: 'List View',
      moveAllToSource: 'Move All to Source',
      moveAllToTarget: 'Move All to Target',
      moveBottom: 'Move Bottom',
      moveDown: 'Move Down',
      moveToSource: 'Move to Source',
      moveToTarget: 'Move to Target',
      moveTop: 'Move Top',
      moveUp: 'Move Up',
      navigation: 'Navigation',
      next: 'Next',
      nextPageLabel: 'Next Page',
      nullLabel: 'Not Selected',
      otpLabel: 'Please enter one time password character {0}',
      pageLabel: 'Page {page}',
      passwordHide: 'Hide Password',
      passwordShow: 'Show Password',
      previous: 'Previous',
      previousPageLabel: 'Previous Page',
      removeLabel: 'Remove',
      rotateLeft: 'Rotate Left',
      rotateRight: 'Rotate Right',
      rowsPerPageLabel: 'Rows per page',
      saveEdit: 'Save Edit',
      scrollTop: 'Scroll Top',
      selectAll: 'All items selected',
      selectLabel: 'Select',
      selectRow: 'Row Selected',
      showFilterMenu: 'Show Filter Menu',
      slide: 'Slide',
      slideNumber: '{slideNumber}',
      star: '1 star',
      stars: '{star} stars',
      trueLabel: 'True',
      unselectAll: 'All items unselected',
      unselectLabel: 'Unselect',
      unselectRow: 'Row Unselected',
      zoomImage: 'Zoom Image',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
    },
  },
  lv: {
    accept: 'Jā',
    addRule: 'Pievienot kārtulu',
    am: 'am',
    apply: 'Piemērot',
    cancel: 'Atcelt',
    choose: 'Izvēle',
    chooseDate: 'izvēlies dienu',
    chooseMonth: 'Izvēlies mēnesi',
    chooseYear: 'Izvēlies gadu',
    clear: 'Notīrīt',
    completed: 'Pabeigts',
    contains: 'Satur',
    custom: 'Pielāgot',
    dateAfter: 'Datums ir pēc',
    dateBefore: 'Datums ir pirms',
    dateFormat: 'dd.mm.yy',
    dateIs: 'Datums ir',
    dateIsNot: 'Datums nav',
    dayNames: [
      'Svētdiena',
      'Pirmdiena',
      'Otrdiena',
      'Trešdiena',
      'Ceturtdiena',
      'Piektdiena',
      'Sestdiena',
    ],
    dayNamesMin: ['Sv', 'Pi', 'Ot', 'Tr', 'Ce', 'Pk', 'Se'],
    dayNamesShort: ['Sve', 'Pir', 'Otr', 'Tre', 'Cet', 'Pie', 'Ses'],
    emptyFilterMessage: 'Rezultāti nav atrasti',
    emptyMessage: 'Nav pieejamu opciju',
    emptySearchMessage: 'Rezultāti nav atrasti',
    emptySelectionMessage: 'Nav neviena izvēlēta vienuma',
    endsWith: 'Beidzas ar',
    equals: 'Vienāds ar',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    filter: 'Filtrēt',
    firstDayOfWeek: 1,
    gt: 'Lielāks par',
    gte: 'Lielāks par vai vienāds ar',
    lt: 'Mazāks par',
    lte: 'Mazāks par vai vienāds ar',
    matchAll: 'Atbilst visi',
    matchAny: 'Atbilst jebkurš',
    medium: 'Vidēja',
    monthNames: [
      'Janvāris',
      'Februāris',
      'Marts',
      'Aprīlis',
      'Maijs',
      'Jūnijs',
      'Jūlijs',
      'Augusts',
      'Septembris',
      'Oktobris',
      'Novembris',
      'Decembris',
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Mai',
      'Jūn',
      'Jūl',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dec',
    ],
    nextDecade: 'Nākamā dekāde',
    nextHour: 'Nākamā stunda',
    nextMinute: 'Nākamā minūte',
    nextMonth: 'Nākamais mēnesis',
    nextSecond: 'Nākamā sekunde',
    nextYear: 'Nākamais gads',
    noFilter: 'Nefiltrēt',
    notContains: 'Nesatur',
    notEquals: 'Nav vienāds ar',
    now: 'Tagad',
    passwordPrompt: 'Ievadiet paroli',
    pending: 'Gaida',
    pm: 'pm',
    prevDecade: 'Iepriekšējā dekāde',
    prevHour: 'Iepriekšējā stunda',
    prevMinute: 'Iepriekšējā minūte',
    prevMonth: 'Iepriekšējais mēnesis',
    prevSecond: 'Iepriekšējā sekunde',
    prevYear: 'Iepriekšējais gads',
    reject: 'Nē',
    removeRule: 'Noņemt kārtulu',
    searchMessage: '{0} rezultāti ir pieejami',
    selectionMessage: '{0} atlasīti vienumi',
    showMonthAfterYear: false,
    startsWith: 'Sākas ar',
    strong: 'Stipra',
    today: 'Šodiena',
    upload: 'Ielādēt',
    weak: 'Vāja',
    weekHeader: 'Ned',
    aria: {
      cancelEdit: 'Atcelt rediģējumu',
      close: 'Aizvērt',
      collapseLabel: 'Sakļaut',
      collapseRow: 'Sakļaut rindu',
      editRow: 'Rindas rediģēšana',
      expandLabel: 'Izvērst',
      expandRow: 'Izvērst rindu',
      falseLabel: 'Nepatiess',
      filterConstraint: 'Filtra ierobežojums',
      filterOperator: 'Filtra operators',
      firstPageLabel: 'Pirmā lapa',
      gridView: 'Tabulas skats',
      hideFilterMenu: 'Paslēpt filtra izvēlni',
      jumpToPageDropdownLabel: 'Pārlēkt uz lapu izvēlni',
      jumpToPageInputLabel: 'Pārlēkt uz lapas ievadi',
      lastPageLabel: 'Pēdējā lapa',
      listView: 'Saraksta skats',
      moveAllToSource: 'Pārvietot visu uz avotu',
      moveAllToTarget: 'Pārvietot visu uz mērķi',
      moveBottom: 'Pārvietot uz apakšu',
      moveDown: 'Pārvietot zemāk',
      moveTop: 'Pārvietot uz augšu',
      moveToSource: 'Pārvietot uz avotu',
      moveToTarget: 'Pārvietot uz mērķi',
      moveUp: 'Pārvietot augstāk',
      navigation: 'Navigācija',
      next: 'Nākamais',
      nextPageLabel: 'Nākamā lapa',
      nullLabel: 'Nav atlasīts',
      otpLabel: 'Lūdzu, ievadiet vienreizēju paroles rakstzīmi {0}',
      pageLabel: 'Lapa {page}',
      passwordHide: 'Slēpt paroli',
      passwordShow: 'Rādīt paroli',
      previous: 'Iepriekšējais',
      previousPageLabel: 'Iepriekšējā lapa',
      removeLabel: 'Noņemt',
      rotateLeft: 'Pagriezt pa kreisi',
      rotateRight: 'Pagriezt pa labi',
      rowsPerPageLabel: 'Rindas lapā',
      saveEdit: 'Saglabāt rediģējumu',
      scrollTop: 'Ritināt uz augšu',
      selectAll: 'Atlasīt visus vienumus',
      selectLabel: 'Izvēlieties',
      selectRow: 'Alasīt rindu',
      showFilterMenu: 'Rādīt filtra izvēlni',
      slide: 'Slaids',
      slideNumber: '{slideNumber}',
      star: '1 zvaigzne',
      stars: '{star} zvaigznes',
      trueLabel: 'Patiess',
      unselectAll: 'Atcelt visu vienumu atlasi',
      unselectLabel: 'Noņemiet atlasi',
      unselectRow: 'Noņemt rindas atlasi',
      zoomImage: 'Attēla tālummaiņa',
      zoomIn: 'Pietuvināt',
      zoomOut: 'Attālināt',
    },
  },
  ru: {
    accept: 'Да',
    addRule: 'Добавить правило',
    am: 'до полудня',
    apply: 'Принять',
    cancel: 'Отмена',
    choose: 'Выбрать',
    chooseDate: 'Выбрать дату',
    chooseMonth: 'Выбрать месяц',
    chooseYear: 'Выбрать год',
    clear: 'Очистить',
    completed: 'Завершено',
    contains: 'Содержит',
    custom: 'Пользовательский',
    dateAfter: 'Дата после',
    dateBefore: 'Дата до',
    dateFormat: 'dd.mm.yy',
    dateIs: 'Дата равна',
    dateIsNot: 'Дата не равна',
    dayNames: [
      'Воскресенье',
      'Понедельник',
      'Вторник',
      'Среда',
      'Четверг',
      'Пятница',
      'Суббота',
    ],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    dayNamesShort: ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
    emptyFilterMessage: 'Результатов не найдено',
    emptyMessage: 'Нет доступных вариантов',
    emptySearchMessage: 'Результатов не найдено',
    emptySelectionMessage: 'Нет выбранного элемента',
    endsWith: 'Заканчивается',
    equals: 'Равно',
    fileSizeTypes: ['Б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб', 'Эб', 'Зб', 'Йб'],
    filter: 'Фильтр',
    firstDayOfWeek: 1,
    gt: 'Более чем',
    gte: 'Более чем или равно',
    lt: 'Меньше чем',
    lte: 'Меньше чем или равно',
    matchAll: 'Сопоставить все',
    matchAny: 'Совпадение с любым',
    medium: 'Нормальный',
    monthNames: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    monthNamesShort: [
      'Янв',
      'Фев',
      'Мар',
      'Апр',
      'Май',
      'Июн',
      'Июл',
      'Авг',
      'Сен',
      'Окт',
      'Ноя',
      'Дек',
    ],
    nextDecade: 'Следующее десятилетие',
    nextHour: 'Следующий час',
    nextMinute: 'Следующая минута',
    nextMonth: 'Следующий месяц',
    nextSecond: 'Следующая секунда',
    nextYear: 'Следующий год',
    noFilter: 'Нет фильтра',
    notContains: 'Не содержит',
    notEquals: 'Не равно',
    now: 'Сейчас',
    passwordPrompt: 'Введите пароль',
    pending: 'В ожидании',
    pm: 'после полудня',
    prevDecade: 'Предыдущее десятилетие',
    prevHour: 'Предыдущий час',
    prevMinute: 'Предыдущая минута',
    prevMonth: 'Предыдущий месяц',
    prevSecond: 'Предыдущая секунда',
    prevYear: 'Предыдущий год',
    reject: 'Нет',
    removeRule: 'Удалить правило',
    searchMessage: '{0} результатов доступно',
    selectionMessage: '{0} элементов выбрано',
    showMonthAfterYear: false,
    startsWith: 'Начинается с',
    strong: 'Хороший',
    today: 'Сегодня',
    upload: 'Загрузить',
    weak: 'Простой',
    weekHeader: 'Нед.',
    aria: {
      cancelEdit: 'Отменить правку',
      close: 'Закрыть',
      collapseLabel: 'Свернуть',
      collapseRow: 'Свернуть строку',
      editRow: 'Редактировать строку',
      expandLabel: 'Развернуть',
      expandRow: 'Развернуть строку',
      falseLabel: 'Неверно',
      filterConstraint: 'Ограничение фильтра',
      filterOperator: 'Оператор фильтра',
      firstPageLabel: 'Первая страница',
      gridView: 'В виде сетки',
      hideFilterMenu: 'Скрыть меню фильтра',
      jumpToPageDropdownLabel: 'Перейти к раскрывающемуся списку страниц',
      jumpToPageInputLabel: 'Перейти к вводу страницы',
      lastPageLabel: 'Последняя страница',
      listView: 'В виде списка',
      moveAllToSource: 'Переместить всё в источник',
      moveAllToTarget: 'Переместить всё в приёмник',
      moveBottom: 'Переместить в конец',
      moveDown: 'Переместить вниз',
      moveTop: 'Переместить в начало',
      moveToSource: 'Переместить в источник',
      moveToTarget: 'Переместить в приёмник',
      moveUp: 'Переместить вверх',
      navigation: 'Навигация',
      next: 'Следующий',
      nextPageLabel: 'Следующая страница',
      nullLabel: 'Не выбран',
      otpLabel: 'Введите символ одноразового пароля {0}',
      pageLabel: '{page}',
      passwordHide: 'Скрыть пароль',
      passwordShow: 'Показать пароль',
      previous: 'Предыдущий',
      previousPageLabel: 'Предыдущая страница',
      removeLabel: 'Удалить',
      rotateLeft: 'Повернуть влево',
      rotateRight: 'Повернуть вправо',
      rowsPerPageLabel: 'Строк на странице',
      saveEdit: 'Сохранить правку',
      scrollTop: 'Прокрутить в начало',
      selectAll: 'Выбрать все строки',
      selectLabel: 'Выбрать',
      selectRow: 'Выбрать строку',
      showFilterMenu: 'Показать меню фильтра',
      slide: 'Слайд',
      slideNumber: '{slideNumber}',
      star: '1 звезда',
      stars: '{star} звёзд',
      trueLabel: 'Верно',
      unselectAll: 'Отменить выбор всех строк',
      unselectLabel: 'Отменить выбор',
      unselectRow: 'Отменить выбор строки',
      zoomImage: 'Увеличить изображение',
      zoomIn: 'Увеличить',
      zoomOut: 'Уменьшить',
    },
  },
}
